import { Vue, Component, Inject, Emit } from 'vue-property-decorator'
import VtDatePicker from '@/components/common/VtDatePicker.vue'
import { initialStatisticalAnalysisSidebarDateInputState, LaboratoryStatisticalAnalysisSidebarDateInput, StatisticalAnalysisSidebarDateInputModel, StatisticalAnalysisSidebarDateInputState } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar-date-and-centers/statistical-analysis-sidebar-date-and-centers.model'
import { Validator } from 'vee-validate'
import sessionStore from '@/session/sessionStore'
import { ModuleOperation } from '@/api/operations/models/module-operation'
import UserappOperationConfigurationServices from '@/api/resources/configuration/peopleManagement/userapp/UserappOperationConfigurationServices'
import { concat } from 'lodash'
import { StatisticalAnalysisCommon } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-sidebar/statistical-analysis-sidebar.models'

@Component({
    components: {
        VtDatePicker
    }
})
export default class StatisticalAnalysisSidebarDateAndCenters extends Vue implements StatisticalAnalysisCommon<StatisticalAnalysisSidebarDateInputModel> {
    @Inject() externalValidator!: Validator
    @Emit()
    finish(): boolean {
        return true
    }
    state: StatisticalAnalysisSidebarDateInputState
    sessionStore = sessionStore
    userAppServices = UserappOperationConfigurationServices

    constructor() {
        super()
        this.state = initialStatisticalAnalysisSidebarDateInputState()
        this.$validator = this.externalValidator
        this.$validator.pause()
    }

    async mounted() {
        await this._updateLaboratories()
        this.finish()
    }

    get startDateExists(): boolean {
        return !!this.state.startDate
    }

    get endDateExists(): boolean {
        return !!this.state.endDate
    }

    get afterDayAllowed(): Date {
        const lastAllowDate = new Date()
        lastAllowDate.setHours(23, 59, 59, 0)
        return lastAllowDate
    }

    clear(): void {
        this.onClearDates()
        this._clearLaboratories()
    }

    getModel(): StatisticalAnalysisSidebarDateInputModel {
        return {
            startDate: this.state.startDate!,
            endDate: this.state.endDate!,
            laboratories: this.state.laboratories.selection
        }
    }

    onUpdateStartDate(date: Date): void {
        this.state.startDate = date
        this.$validator.reset({ name: this.$tc('statisticalAnalysis.sidebar.startDate') })
    }

    onUpdateEndDate(date: Date): void {
        this.state.endDate = date
        this.$validator.reset({ name: this.$tc('statisticalAnalysis.sidebar.endDate') })
    }

    onSelectLaboratory(labs: LaboratoryStatisticalAnalysisSidebarDateInput[]): void {
        this.state.laboratories.selection = labs
    }

    onClearDates(): void {
        this.state = {
            ...this.state,
            startDate: null,
            endDate: null
        }
    }

    private async _updateLaboratories(): Promise<void> {
        if (this.$store.getters.userInformation) {
            const permissions = await this.userAppServices.getUserappOperationsByUserappId(this.$store.getters.userInformation.id)
            const filteredPermissions = permissions.filter((permission: any) => permission.operation.code === ModuleOperation.STATISTICS_PANEL_ACCESS)

            this.state.laboratories.list = filteredPermissions.map((permission: any) => {
                return {
                    labId: permission.laboratory.labId,
                    labName: permission.laboratory.labName
                }
            })
            this.state.laboratories.selection = this._getLaboratorySelectedDefault()
        }
    }

    private _getLaboratorySelectedDefault(): LaboratoryStatisticalAnalysisSidebarDateInput[] {
        const labId = this.$store.getters.labId
        const foundLaboratory = this.state.laboratories.list.find((lab: LaboratoryStatisticalAnalysisSidebarDateInput) => lab.labId === labId)
        if (foundLaboratory) {
            return concat([], foundLaboratory)
        }
        return []
    }

    private _clearLaboratories(): void {
        this.state = {
            ...this.state,
            laboratories: {
                ...this.state.laboratories,
                selection: this._getLaboratorySelectedDefault()
            }
        }
    }
}
